export function setPendingModal(data: ModalState) {
  localStorage.setItem("pending-modal", JSON.stringify(data));
}

export function getPendingModal() {
  const raw = localStorage.getItem("pending-modal");

  if (raw) {
    try {
      const modal = JSON.parse(raw);
      if (modal?.type === "transfer-in-initiated") {
        return modal as TransferInInitiatedModalState;
      }
      if (modal?.type === "distribution-code") {
        return modal as DistributionCodeModalState;
      }
      if (modal?.type === "standalone-distribution-code") {
        return modal as StandaloneDistributionCodeModalState;
      }
      if (modal?.type === "charge-completed") {
        return modal as ChargeCompletedModalState;
      }
      if (modal?.type === "kyoto-representative-campaign-completed") {
        return modal as KyotoRepresentativeCampaignCompletedModalState;
      }
    } catch {
      /* ignore parse errors */
      localStorage.removeItem("pending-modal");
    }
  }

  return null;
}

export function clearPendingModal() {
  localStorage.removeItem("pending-modal");
}
